export default __webpack_public_path__ + "static/media/do-1@2x.b1ed7a82.jpg";